import React from "react";

const NoTransactions = ({ monthLabel, isSearchEmpty = false }) => {
  return (
    <div className="flex flex-column align-items-center justify-content-center gap-3 py-7 text-center">
      <div
        className="flex align-items-center justify-content-center border-circle surface-100"
        style={{ width: "80px", height: "80px" }}
      >
        <i className={`pi ${isSearchEmpty ? "pi-search" : "pi-receipt"} text-4xl text-300`} />
      </div>
      <div className="flex flex-column gap-1">
        <span className="text-xl font-semibold text-700">
          {isSearchEmpty ? "No results found" : "No transactions"}
        </span>
        <span className="text-sm text-400">
          {isSearchEmpty
            ? "No transactions match your search. Try a different Transaction ID."
            : `No charging sessions were recorded for ${monthLabel}.`}
        </span>
      </div>
    </div>
  );
};

export default NoTransactions;
